import React from 'react'
import PropTypes from 'prop-types'

const highlightCardBox = (color, box) => box ? <div className={[color, 'highlight-card__box text-white leading-none text-xs w-8 h-8 mr-3 rounded-lg flex items-center justify-center flex-shrink-0 xl:mr-4 xl:w-14 xl:h-14 xl:text-lg'].join(' ')}>{box}</div> : null
const highlightCardTitle = title => title ? <div className='font-medium text-sm xl:text-base'>{title}</div> : null
const highlightCardContent = content => content ? <div className='text-2xs xl:text-sm text-gray-400'>{content}</div> : null
const highlightCardActions = actions => actions ? <div className='ml-2 group space-x-1 flex-shrink-0'>{actions}</div> : null

function HighlightCard ({ box, title, content, color, backgroundColor = 'bg-white', actions }) {
  const colors = {
    primary: 'bg-primary-500',
    red: 'bg-red-500',
    green: 'bg-green-500',
    yellow: 'bg-yellow-300',
    background: 'bg-background'
  }

  const colorClassName = colors[color] || colors.primary

  return (
    <div className={'highlight-card overflow-hidden rounded-lg flex items-center w-full flex-grow xl:max-w-md ' + backgroundColor}>
      <div className='px-3 py-4 flex items-center w-full xl:px-4 xl:py-5'>
        {highlightCardBox(colorClassName, box)}
        <div className='flex-grow'>
          {highlightCardTitle(title)}
          {highlightCardContent(content)}
        </div>
        {highlightCardActions(actions)}
      </div>
    </div>
  )
}

HighlightCard.propTypes = {
  /**
     * Background color
     */
  color: PropTypes.oneOf(['primary', 'red', 'green', 'yellow', 'background']),
  /**
     * Controls the content of the box
     */
  box: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * Controls the text content of the box
     */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * Controls the content below the title
     */
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * Add actions to the card. (buttons etc.)
     */
  actions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ])
}

export default HighlightCard
